import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl/dist';

import Tooltip from '../../../../components/common/tooltip/Tooltip';
import { processCommon } from '../../../../utils/dashboard/processCommon';
import { environmentSelector } from '../../../../selectors/commonSelectors';

const EnrolleesTooltipStyled = styled(Tooltip)`
  display: inline;
`;

const EnrollmentContainerStyled = styled.div`
  :first-child{
    margin-bottom: 30px;
  
`;

const EnrolmentType = styled.span`
  font-weight: bold;
`;

const Enrollment = (props) => {
    const {
        environment: {
            localDates: {
                serverDate
            }
        },
        enrollment: {
            id,
            type,
            enrollees,
            coverageStartDate,
            coverageEndDate,
            plan: {
                planName,
                issuerName,
                netPremium
            }
        }
    } = props;

    return (
        <EnrollmentContainerStyled>
            <EnrolleesTooltipStyled
                id='plans.cnt_members'
                content={processCommon.getEnrolleesTooltipContent(enrollees, serverDate)}
                index={`enrollment_${id}`}
                replacement={{ numMember: enrollees.length }}
                place='left'
                contentClassName='gi-txt__capitalize'
            />
            <EnrolmentType>
                <FormattedMessage id='common.enrolled_in' values={{ type: <FormattedMessage id={`common.${type.toLowerCase()}`} /> }}/><br/>
            </EnrolmentType>
            <div>
                <div>{issuerName}{' '}{planName}</div>
                <div>
                    <FormattedMessage id='common.from' tagName='span'/> {coverageStartDate}&nbsp;
                    <FormattedMessage id='common.to' tagName='span'/>  {coverageEndDate}
                </div>
                <div>
                    <FormattedMessage id='common.net_premium'/> <b>${netPremium}</b>
                </div>
            </div>
                
        </EnrollmentContainerStyled>
    );
};
const mapStateToProps = createStructuredSelector({
    environment: environmentSelector
});

export default connect(mapStateToProps)(Enrollment);